// extracted by mini-css-extract-plugin
module.exports = {"loader-wrapper":"src-components-___App__loader-wrapper___2iMkN"};